export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/b552ae94a3baa9664c4076d726380c66.svg";